export const OutgoingEventsHybridModel = {
	tableConfig: {
		hasDeleteAction: false,
	},
	model: [{
		label: 'integration',
		key: 'integration'
	}],

	formBuilderConfig: {
		integration: {
			DataType: 'String',
			DisplayText: 'integration',
			Name: 'integration',
			required: false
		}
	}
}

export class OutgoingEventsHybridParamsModel {
	customUrl?: string;
	customSaveUrl?: string;
	limit?: number;
	hasDeleteAction?: boolean;

	constructor() {
		this.customUrl = '';
		this.customSaveUrl = '';
		this.limit = 100;
		this.hasDeleteAction = true;
	}
}

export class EventSetting {
	eventName: string;
	postIf: 'Always' | 'Open' | 'Closed';
	enabled: boolean;

	constructor() {
		this.enabled = true;
	}
}

export class DataSection {
	product: EventSetting[];
	productHybrid: EventSetting[];
	productNonHybrid: EventSetting[];
}

export class CmpRelation {
	[key: string]: string; // dynamic keys like 'OutgoingComment': 'Comment'
}

export class RootModel {
	data: DataSection;
	cmpRelation: CmpRelation;
	postValues: Array<'Always' | 'Open' | 'Closed'>;
}

export interface OutgoingEventLabels {
	[key: string]: string;
	OutgoingComment?: string;
	OutgoingScheduled?: string;
	OutgoingAssigned?: string;
	OutgoingAcceptedByVendor?: string;
	OutgoingInspectionComplete?: string;
	OutgoingOnHold?: string;
	OutgoingResume?: string;
	OutgoingCompleted?: string;
	OutgoingRevisionRequested?: string;
	OutgoingRevisionReceived?: string;
	OutgoingOrderUpgraded?: string;
	OutgoingNewDocument?: string;
}

